import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreen } from 'Screen/ScreenContext';
import { IconBuildingBank } from '@tabler/icons-react';
import useChargebackDetails from './hooks/useChargebackDetails';
import ChargebackDetailsView from './view';
import SubmitDisputeModal from '@components/_modals/Billing/SubmitDisputeModal';

export default function ChargebackDetails({ chargebackId }) {
    const navigate = useNavigate();
    const disputeModalRef = useRef({});
    const { chargeback, loading, error, refetch } = useChargebackDetails(chargebackId);
    const { setBreadcrumb } = useScreen();

    useEffect(() => {
        setBreadcrumb([
            { label: 'Banking', href: '/banking', icon: <IconBuildingBank size={18} /> },
            { label: 'Chargebacks', href: '/banking/chargebacks' },
            { label: loading ? '•••' : String(chargeback?.id || chargebackId) },
        ]);
        return () => setBreadcrumb(null);
    }, [loading, chargeback?.id, chargebackId]);

    return (
        <>
            <ChargebackDetailsView
                chargeback={chargeback}
                loading={loading}
                error={error}
                navigate={navigate}
                onDispute={() => disputeModalRef.current.open({ chargebackId }, refetch)}
            />
            <SubmitDisputeModal modalRef={disputeModalRef} />
        </>
    );
}
